import dayjs from 'dayjs';

export type Preset = {
  label: string;
  value: string;
  getRange: () => [Date, Date];
};

export const PRESET_REGISTRY = {
  today: {
    label: 'Today',
    value: 'today',
    getRange: () => {
      const d = new Date();
      return [d, d] as [Date, Date];
    },
  },
  yesterday: {
    label: 'Yesterday',
    value: 'yesterday',
    getRange: () => {
      const y = dayjs().subtract(1, 'day').toDate();
      return [y, y] as [Date, Date];
    },
  },
  last_7_days: {
    label: 'Last 7 Days',
    value: 'last_7_days',
    getRange: () => [dayjs().subtract(6, 'day').toDate(), new Date()] as [Date, Date],
  },
  next_7_days: {
    label: 'Next 7 Days',
    value: 'next_7_days',
    getRange: () => [new Date(), dayjs().add(6, 'day').toDate()] as [Date, Date],
  },
  last_week: {
    label: 'Last Week',
    value: 'last_week',
    getRange: () => {
      const start = dayjs().subtract(1, 'week').startOf('week').toDate();
      const end = dayjs().subtract(1, 'week').endOf('week').toDate();
      return [start, end] as [Date, Date];
    },
  },
  this_month: {
    label: 'This Month',
    value: 'this_month',
    getRange: () => {
      const start = dayjs().startOf('month').toDate();
      const end = new Date();
      return [start, end] as [Date, Date];
    },
  },
  rest_of_month: {
    label: 'Rest of Month',
    value: 'rest_of_month',
    getRange: () => {
      const now = new Date();
      const end = dayjs().endOf('month').toDate();
      return [now, end] as [Date, Date];
    },
  },
  last_month: {
    label: 'Last Month',
    value: 'last_month',
    getRange: () => {
      const start = dayjs().subtract(1, 'month').startOf('month').toDate();
      const end = dayjs().subtract(1, 'month').endOf('month').toDate();
      return [start, end] as [Date, Date];
    },
  },
  past_12_months: {
    label: 'Last 12 Months',
    value: 'past_12_months',
    getRange: () => {
      const start = dayjs().subtract(11, 'month').startOf('month').toDate();
      const end = new Date();
      return [start, end] as [Date, Date];
    },
  },
} as const;

export type PresetKey = keyof typeof PRESET_REGISTRY;

export const getPresetsByKeys = (keys: PresetKey[]): Preset[] => {
  return keys.map(key => PRESET_REGISTRY[key]);
};

export const defaultPresets: Preset[] = Object.values(PRESET_REGISTRY);

export const getRange = (period: string): [Date | null, Date | null] => {
  const preset = Object.values(PRESET_REGISTRY).find(p => p.value === period);
  if (!preset) return [null, null];
  return preset.getRange();
};
